// extracted by mini-css-extract-plugin
module.exports = {"transparent":"page_transparent__SVVLd"};